module.exports = __webpack_public_path__ + "static/media/thief_girl-safe.9f3a7405.svg";